<template>
  <div class="start-new-session-wrapper">
    <MainNavigation 
      page-name="Session Settings" 
      :routeIndex="routeIndex"
      :currentClass="currentClass"
      />
    <Loader v-if="!currentClass || !currentSession" />
    <ClassItemBanner
      v-if="currentClass.classId != null"
      :sessionEnded="true"
      :currentClass="currentClass"
    />
    <div v-if="currentSession.sessionId != null" class="settings-container">
      <h1>Settings</h1>
      <p>Choose settings for your session.</p>
      <div class="game-mode-settings">
        <h4>Game Mode</h4>
        <p>
          We recommend active mode for classrooms with space for students to
          walk around.
        </p>
        <div class="game-mode-button-settings">
          <div>
            <input
              id="active"
              name="game-mode"
              type="radio"
              value="Active"
              v-model="currentSession.sessionSettings.gameMode"
            />
            <label for="active">Active</label>
          </div>
          <div>
            <input
              id="seated"
              name="game-mode"
              type="radio"
              value="Seated"
              v-model="currentSession.sessionSettings.gameMode"
            />
            <label for="seated">Seated</label>
          </div>
        </div>
      </div>
      <hr />
      <div class="room-time-limit-container">
        <h2>Room Time Limit</h2>
        <div class="time-limit-settings">
          <h4>Enable Time Limit</h4>
          <label class="switch" for="time-limit">
            <input
              type="checkbox"
              id="time-limit"
              v-model="
                currentSession.sessionSettings.isTimeLimitEnabled
              "
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="minutes-section">
          <h4>Minutes per room</h4>
          <div class="flex-container-row">
            <div
              :class="
                currentSession.sessionSettings.isTimeLimitEnabled
                  ? 'input-counter ' + disabledClass
                  : 'input-counter disabled ' + disabledClass
              "
            >
              <span class="material-icons-round button" @click="dec(1)">remove_circle</span>
              <input
                class="clock__input--number"
                type="number"
                :min="5"
                :max="90"
                v-model.number="
                  currentSession.sessionSettings.timeLimit
                "
                @change="(e) => timelimit()"
                id="time-limit-number"
                :disabled="
                  currentSession.sessionSettings
                    .isTimeLimitEnabled == false
                "
              />
              <span class="material-icons-round" @click="inc(1)">add_circle</span>
            </div>
            <div>
              <span><em>Each room on average takes 35-40 minutes</em><br></span>
              <span><em>Time limits must be between 5–90 minutes</em></span>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="volume-settings-container">
        <h2>Volume</h2>
        <div class="volume-settings">
          <h4>Background Music</h4>
          <label class="switch on-off">
            <input
              type="checkbox"
              class="light-switch"
              v-model="
                currentSession.sessionSettings.backgroundMusic
              "
            />
            <span class="slider"></span>
          </label>
        </div>
        <div class="volume-settings">
          <h4>Narration</h4>
          <label class="switch on-off">
            <input
              type="checkbox"
              class="light-switch"
              v-model="currentSession.sessionSettings.narration"
            />
            <span class="slider"></span>
          </label>
        </div>
        <div class="volume-settings">
          <h4>Sound Effects</h4>
          <label class="switch on-off">
            <input
              type="checkbox"
              class="light-switch"
              v-model="currentSession.sessionSettings.soundEffects"
            />
            <span class="slider"></span>
          </label>
        </div>
      </div>
      <button class="save-button save-settings" @click="setSessionSettings()">
        <span>Save Session Settings</span>
      </button>
    </div>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import Loader from "../components/Loader.vue";
import ClassItemBanner from "../components/ClassItemBanner.vue";

export default {
  name: "Start New Session",
  components: {
    MainNavigation,
    Loader,
    ClassItemBanner
  },
  props: ["name", "routeIndex"],
  computed: {
    allClasses() {
      return this.$store.state.allClasses;
    },
    currentClass() {
      for (let i = 0; i < this.$store.state.allClasses.length; i++) {
        const thisClass = this.$store.state.allClasses[i];
        if (thisClass.classInfo.nickname == this.$route.params.name) {
          return this.$store.state.allClasses[i];
        }
      }
      return {
        classId: null,
        classInfo: {
          nickname: null,
          checkedDay: [],
          grade: null,
          subject: null,
        },
        studentList: [],
      };
    },
    allStudents() {
      return this.$store.state.studentList;
    },
    dataUpdated() {
      return this.$store.state.dataUpdated;
    },
    currentSession() {
      return this.$store.state.currentSession;
    },
    sessionSettings() {
      return this.currentSession.sessionSettings;
    },
    disabledClass(){
      if (this.currentSession.sessionSettings.timeLimit <= 5){
        return "disabled_dec"
      } else if  (this.currentSession.sessionSettings.timeLimit >= 90){
        return "disabled_inc"
      } else {
        return "active"
      }
    },
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  }, 
  mounted() {
    this.$store.commit("CLEAR_CURRENT_SESSION");
  }, 
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  methods: {
    beforeWindowUnload(e) {
      e.preventDefault()
      e.returnValue = ''
    },
    timelimit() {
      if (this.currentSession.sessionSettings.timeLimit > 90) {
        const overrage =
          this.currentSession.sessionSettings.timeLimit - 90;
        this.$store.commit("DECREMENT_TIMELIMIT", overrage);
      }
      if (this.currentSession.sessionSettings.timeLimit < 5) {
        const overrage =
          5 - this.currentSession.sessionSettings.timeLimit;
        this.$store.commit("INCREMENT_TIMELIMIT", overrage);
      } else {
        return;
      }
    },
    inc(amt) {
      if (!this.currentSession.sessionSettings.isTimeLimitEnabled)
        return;
      if (this.currentSession.sessionSettings.timeLimit <= 89) {
        this.$store.commit("INCREMENT_TIMELIMIT", amt);
      }
    },
    dec(amt) {
      if (!this.currentSession.sessionSettings.isTimeLimitEnabled)
        return;
      if (this.currentSession.sessionSettings.timeLimit >= 6) {
        this.$store.commit("DECREMENT_TIMELIMIT", amt);
      }
    },
    setSessionSettings() {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          sessionId: this.currentSession.sessionId,
          sessionSettings: this.currentSession.sessionSettings,
        },
        opCode: this.$store.state.opCodes.SetSessionSettings,
      });
      this.$router.push({
        name: "start-session",
      });
    },
  },
};
</script>

<style lang="scss">
.start-new-session-wrapper {
  text-align: left;
}

.settings-container {
  h1 {
    margin-bottom: 0;
    & + p {
      margin-top: 0;
    }
  }
  .input-counter {
    -webkit-transition: 0.4s;
    transition: 0.4s;
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}


.room-time-limit-container {
  margin-bottom: 1em;
  .minutes-section,
  .time-limit-settings {
    margin-bottom: 1em;
  }
}

.volume-settings-container {
  margin-bottom: 2em;
  .volume-settings {
    p {
      margin-bottom: 0.5em;
    }
  }
}

.game-mode-settings {
  display: none;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $tan;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 15px;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.light-switch:checked + .slider:before {
  -webkit-transform: translateX(96.5%) !important;
  -ms-transform: translateX(96.5%) !important;
  transform: translateX(96.5%) !important;
}

.on-off {
  position: relative;
  width: 100%;
}

.on-off .slider::before {
  width: 50%;
}

.on-off:before,
.on-off:after {
  position: absolute;
  line-height: 34px;
  font-size: 14px;
  z-index: 2;
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  color: $darkbrown;
}

.on-off:before {
  content: "OFF";
  left: 100px;
}

.on-off:after {
  content: "ON";
  right: 100px;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.number {
  margin: 100px;
}
.clock__btn--subtract,
.clock__btn--add {
  width: 20px;
  height: 20px;
  background: #f2f2f2;
  border-radius: 4px;
  padding: 8px 5px 8px 5px;
  border: 1px solid #ddd;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
}
.clock__input--number {
  height: 34px;
  width: 100px;
  text-align: center;
  font-size: 26px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: inline-block;
  vertical-align: middle;
}

button.save-settings {
  width: 100%;
}
</style>